import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getdataInvoice_H = () => {
  return httpClient.get(server.INVOICE_H + `/get`);
};

export const getdataInvoice_HBycompany = (query) => {
  return httpClient.get(server.INVOICE_H + `/getbycompany`, query);
};

// Parameters:getdataInvoice_HBycompany_Pagination
// - company_id (required): รหัสบริษัท
// - department_id (optional): รหัสแผนก
// - page (optional, default=1): หน้าที่ต้องการ
// - limit (optional, default=100): จำนวนรายการต่อหน้า
// - sortBy (optional, default="ih.id"): ฟิลด์ที่ใช้จัดเรียง
// - sortOrder (optional, default="ASC"): ทิศทางการจัดเรียง (ASC/DESC)
export const getdataInvoice_HBycompany_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  department_id
) => {
  return httpClient.get(server.INVOICE_H + `/getbycompany-pagination`, {
    params: {
      company_id: company_id,
      department_id: department_id,
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortOrder: sortOrder,
    },
  });
};

// Search filters
// company_search: '1',        // optional
// department_search: '5',     // optional
// search_status: 'Invoice',   // optional
// datefrom: '2024-01-01',     // optional
// dateto: '2024-12-31',       // optional
// search: 'INV'               // optional - ค้นหาข้อความ
export const getdataInvoice_HBycompany_Pagination_V2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  department_id,
  company_search,
  department_search,
  search_status,
  datefrom,
  dateto,
  search
) => {
  return httpClient.get(server.INVOICE_H + `/getbycompany-pagination-v2`, {
    params: {
      company_id: company_id,
      department_id: department_id,
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortOrder: sortOrder,
      company_search: company_search,
      department_search: department_search,
      search_status: search_status,
      datefrom: datefrom,
      dateto: dateto,
      search: search,
    },
  });
};

export const getdataAdjustInvoice_HBycompany = (query) => {
  return httpClient.get(server.INVOICE_H + `/getAdjustbycompany`, query);
};

// Parameters: getdataAdjustInvoice_HBycompany_Pagination
// - company_id (required): ID ของบริษัท
// - page (optional): หน้าที่ต้องการ (default: 1)
// - limit (optional): จำนวน records ต่อหน้า (default: 10)
// - sortBy (optional): ชื่อคอลัมน์ที่ต้องการเรียง (default: 'ih.id')
// - sortOrder (optional): ทิศทางการเรียง ASC หรือ DESC (default: 'ASC')
export const getdataAdjustInvoice_HBycompany_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id
) => {
  return httpClient.get(server.INVOICE_H + `/getAdjustbycompanyPagination`, {
    params: {
      company_id: company_id,
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortOrder: sortOrder,
    },
  });
};

// Search filters
// company_search: '1',        // optional
// department_search: '5',     // optional
// search_status: 'Invoice',   // optional
// datefrom: '2024-01-01',     // optional
// dateto: '2024-12-31',       // optional
// search: 'INV'               // optional - ค้นหาข้อความ
export const getdataAdjustInvoice_HBycompany_Pagination_V2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  company_search,
  department_search,
  search_status,
  datefrom,
  dateto,
  search
) => {
  return httpClient.get(server.INVOICE_H + `/getAdjustbycompanyPaginationV2`, {
    params: {
      company_id: company_id,
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortOrder: sortOrder,
      company_search: company_search,
      department_search: department_search,
      search_status: search_status,
      datefrom: datefrom,
      dateto: dateto,
      search: search,
    },
  });
};

export const getdataByIdInvoice_H = (id) => {
  return httpClient.get(server.INVOICE_H + `/getbyid/${id}`);
};

export const getPrintDataByIdAndCusTypeInvoice_H = (id, customer_type) => {
  return httpClient.get(
    server.INVOICE_H +
    `/getinvoice_h_to_print_byid_and_customer_type/${id}/${customer_type}`
  );
};

export const getdataByIdInvoice_HRC = (id) => {
  return httpClient.get(server.INVOICE_H + `/getbyidrc/${id}`);
};

export const getPrintDataByIdAndCusTypeInvoice_HRC = (id, customer_type) => {
  return httpClient.get(
    server.INVOICE_H +
    `/getinvoice_h_to_print_byid_and_customer_type_rc/${id}/${customer_type}`
  );
};

export const addInvoice_H = (data) => {
  return httpClient.post(server.INVOICE_H + `/`, data);
};

export const addInvoice_HFile = (id, data) => {
  return httpClient.post(server.INVOICE_H + `/create_file/${id}`, data);
};

export const addInvoice_H_Geninv_id = (data) => {
  return httpClient.post(server.INVOICE_H + `/addgeninv_id`, data);
};

export const addInvoice_HCN = (data) => {
  return httpClient.post(server.INVOICE_H + `/cn`, data);
};

export const addInvoice_H_Geninv_idCN = (data) => {
  return httpClient.post(server.INVOICE_H + `/addgeninv_idCN`, data);
};

export const updateInvoice_H = (id, data) => {
  return httpClient.put(server.INVOICE_H + `/${id}`, data);
};

export const updateInvoice_H_Geninv_id = (id, data) => {
  return httpClient.put(server.INVOICE_H + `/updategeninv_id/${id}`, data);
};

export const deleteInvoice_H = (id) => {
  return httpClient.delete(server.INVOICE_H + `/${id}`);
};

export const getcreditnote_ListBycompany = (query) => {
  return httpClient.get(
    server.INVOICE_H + `/getcreditnotebycompany_list`,
    query
  );
};

export const getcreditnote_ListBycompany_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id
) => {
  return httpClient.get(
    server.INVOICE_H + `/getcreditnotebycompany_list_pagination`,
    {
      params: {
        company_id: company_id,
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
      },
    }
  );
};

export const getcreditnote_ListBycompany_Pagination_V2 = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  datefrom,
  dateto,
  search
) => {
  return httpClient.get(
    server.INVOICE_H + `/getcreditnotebycompany_list_pagination_v2`,
    {
      params: {
        company_id: company_id,
        page: page,
        limit: limit,
        sortBy: sortBy,
        sortOrder: sortOrder,
        datefrom: datefrom,
        dateto: dateto,
        search: search,
      },
    }
  );
};

export const getReceive_ListBycompany = (query) => {
  return httpClient.get(server.INVOICE_H + `/getreceivebycompany_list`, query);
};
export const getReceiveSelect_ListBycompany = (query) => {
  return httpClient.get(
    server.INVOICE_H + `/getreceiveselectlistbycompany_list`,
    query
  );
};

export const getcreditnoteBycompany = (query) => {
  return httpClient.get(server.INVOICE_H + `/getcreditnotebycompany`, query);
};

export const getReceiveDetail = (type, data) => {
  return httpClient.post(server.INVOICE_H + `/getsoreceive/${type}`, data);
};

export const getdataReportInv = (query) => {
  return httpClient.get(server.INVOICE_H + `/searchinv_report`, query);
};
export const getdataReportRc = (query) => {
  return httpClient.get(server.INVOICE_H + `/searchreceive_report`, query);
};

export const getdataReceiveReportInv = (query) => {
  return httpClient.get(server.INVOICE_H + `/searchreceive_report`, query);
};

export const getdataReportInv_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  datefrom,
  dateto,
  customer_id,
  company_inv,
  department,
  status
) => {
  return httpClient.get(server.INVOICE_H + `/searchinv_report_pagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      company_id,
      datefrom,
      dateto,
      customer_id,
      company_inv,
      department,
      status,
    },
  });
};

export const getdataReportRc_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  datefrom,
  dateto,
  customer_id,
  department,
  status
) => {
  return httpClient.get(server.INVOICE_H + `/searchreceive_report_pagination`, {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      company_id,
      datefrom,
      dateto,
      customer_id,
      department,
      status,
    },
  });
};
